/**
 * Stable device fingerprint (random UUID stored in localStorage) + simple device
 * info parser. Backend re-parses the User-Agent server-side, so this is just for
 * carrying a stable per-device id across re-logins.
 */
const KEY = "pm_device_id";

export function getDeviceId() {
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      // Prefer crypto UUID; fall back to Math.random for very old browsers
      id = (window.crypto && typeof window.crypto.randomUUID === "function")
        ? window.crypto.randomUUID()
        : `pm-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch { return null; }
}

export function getDeviceName() {
  const ua = navigator.userAgent || "";
  const low = ua.toLowerCase();
  let device = "Desktop";
  if (/mobile|iphone/.test(low)) device = "Mobile";
  else if (/ipad|tablet/.test(low)) device = "Tablet";
  let browser = "Browser";
  if (/edg\//.test(low)) browser = "Edge";
  else if (/firefox/.test(low)) browser = "Firefox";
  else if (/chrome/.test(low) && /safari/.test(low)) browser = "Chrome";
  else if (/safari/.test(low)) browser = "Safari";
  let os = "";
  if (/windows/.test(low)) os = "Windows";
  else if (/iphone|ipad/.test(low)) os = "iOS";
  else if (/android/.test(low)) os = "Android";
  else if (/mac os|macintosh/.test(low)) os = "macOS";
  else if (/linux/.test(low)) os = "Linux";
  return `${device} · ${browser}${os ? " · " + os : ""}`;
}
